<template>
    <base-dialog :loading="loading" :value="dialog" :width="460" :title="dialogTitle" @input="val => { if (!val) hide() }" @close="hide">
        <v-row>
            <v-col cols="12" v-if="selectDate">
                <kimsa-date-picker :label="$t('routines.from')" solo flat dense color="secondary"
                    @change="date = $event" :value="date" ref="start" bolder-label />
            </v-col>
            <v-col cols="12">
                <kimsa-text-field no-elevation bolder-label dense :label="$t('common.versus_short')"
                    @change="versus = $event" :value="versus" force-value />
            </v-col>
            <v-col cols="12">
                <kimsa-text-field no-elevation bolder-label dense :label="$tc('common.minutes', 2)"
                    @change="minutes = $event" :value="minutes" force-value />
            </v-col>
        </v-row>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.save')" :disabled="disabled" :loading="loading"
                @confirm="setCompetence" />
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { db } from "@/utils/Firebase";

import { addAssignedCompetenceGroup, deleteAssignedRoutinesGroup, getPayloadBaseAssignedCompetence, updateAssignedCompetenceGroup } from "../../../utils/Exercises";
import KimsaDatePicker from '../../common/inputs/KimsaDatePicker.vue';
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";

export default {
    name: "AddCompetenceDialog",
    components: { KimsaTextField, KimsaDatePicker, BaseDialog, DialogActions },
    props: {
        currentSelection: {
            type: Object,
            default: null,
        },
        collection: {
            type: String,
            default: null,
        },
        assignedRoutineToReplace: {
            type: Array,
            default: () => [],
        },
        coachId: {
            type: String,
            default: null,
        },
        selectDate: {
            type: Boolean,
            default: false,
        },
        routineNumber: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            versus: '',
            date: null,
            editMode: false,
            competence: null,
            minutes: null,
        }
    },
    computed: {
        dialogTitle(vm = this) {
            return `${vm.editMode ? vm.$t('common.edit') : vm.$t('common.add')} ${vm.$t('common.competence')}`
        },
        disabled(vm = this) {
            return !vm.versus || (vm.selectDate && !vm.date)
        },
        competenceId(vm = this) {
            return vm.competence?.id || null
        },
    },
    methods: {
        show(date, competence = null) {
            const vm = this
            vm.setDefaults(competence, date)
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this
            vm.competence = null
            vm.versus = ''
            vm.date = null
            vm.minutes = null
            vm.editMode = false
        },
        setDefaults(competence, date) {
            const vm = this
            vm.date = date || null
            vm.competence = competence
            vm.versus = competence?.versus || ''
            vm.minutes = competence?.minutes || null
            vm.editMode = !!vm.versus
        },
        async setCompetence() {
            const vm = this
            if (vm.loading) return
            await vm.withLoading(async () => {
            if (vm.selectDate) {
                let routineRef = await db.collection(vm.collection).where('studentId', '==', vm.currentSelection.objectID).where('rawDate.full', '==', vm.date).get()
                if (routineRef.docs.length > 0) {
                    vm.toast(vm.$t('common.busy_date_competence'), 'error')
                    return
                }
            }

            if (vm.editMode) {
                await db.collection(vm.collection).doc(vm.competence.id).update({ versus: vm.versus, minutes: vm.minutes })
                if (vm.collection === 'groupAssignedRoutines') {
                    const competenceRef = await db.collection(vm.collection).doc(vm.competence.id).get()
                    await updateAssignedCompetenceGroup(competenceRef.data()?.assignedRoutinesIds, vm.versus, vm.minutes)
                }
            } else {
                let payloadCompetence = getPayloadBaseAssignedCompetence(vm.versus, vm.minutes, vm.date, vm.coachId, vm.routineNumber)

                if (vm.collection === 'assignedRoutines') {
                    payloadCompetence.studentId = vm.currentSelection.objectID
                } else {
                    payloadCompetence.teamId = vm.currentSelection.teamId || null
                    payloadCompetence.groupId = vm.currentSelection.id
                }

                const arRef = await db.collection(vm.collection).add(payloadCompetence)
                const competenceId = arRef.id
                vm.competence = { id: competenceId, assignedRoutineId: competenceId, ...payloadCompetence }

                if (vm.collection === 'groupAssignedRoutines') {
                    let students = [...vm.currentSelection.students]
                    if (vm.assignedRoutineToReplace.length > 0) {
                        let toDelete = vm.assignedRoutineToReplace.filter(ar => ar.replace).map(ar => {
                            return ar.assignedRoutineId
                        })
                        if (toDelete.length > 0) await deleteAssignedRoutinesGroup(toDelete)
                        let skippedStudents = vm.assignedRoutineToReplace.filter(ar => !ar.replace).map(ar => {
                            return ar.studentId
                        })
                        if (skippedStudents.length > 0) students = students.filter(st => !skippedStudents.includes(st))
                    }
                    await addAssignedCompetenceGroup({ id: competenceId, ...payloadCompetence, date: vm.date }, students)
                }
            }

            vm.toast(vm.$t('common.competence_saved'))
            vm.$emit('saved', { ...vm.competence, versus: vm.versus, minutes: vm.minutes, date: vm.date })
            vm.hide()
            })
        },
    },

}
</script>